/**
 * Per `onOpenAutoFocus` dei popover di scelta: su un touch screen la ricerca
 * non prende il focus all'apertura, così la tastiera non copre l'elenco; si
 * tocca il campo per cercare. Con mouse e tastiera il focus resta sul campo.
 */
export function senzaTastieraSuTouch(evento: Event) {
  if (window.matchMedia('(pointer: coarse)').matches) evento.preventDefault();
}
